module.exports = __webpack_public_path__ + "94f66a5fc9337d5734f6eaf825113cd8.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/thumbnail/public/picture/Canucks_0.jpg
// module id = 562
// module chunks = 0